/* global chartLanguage, bocAmchart, AmCharts */

/**
 * Returns the proper quarter label  based on the date
 *
 * @param {date} date       the date object
 * @returns {string}        the proper string including the quarter
 */
bocAmchart.quarterFunction = function (date) {
    var quarterLabel = "Q";
    if (chartLanguage === "fr") {
        quarterLabel = "T";
    }
    var month = date.getMonth();
    var quarter;
    if (month <= 2) {
        quarter = 1;
    } else if (month <= 5) {
        quarter = 2;
    } else if (month <= 8) {
        quarter = 3;
    } else {
        quarter = 4;
    }

    return date.getFullYear() + quarterLabel + quarter;
};

/**
 * Returns the default date for all amcharts using date as category, unless changed otherwise
 *
 * @param {date|string} categoryLabel       the date object or other category label
 * @returns {string}                        the proper string for the date
 */
bocAmchart.defaultDate = function (categoryLabel) {

    var label = categoryLabel;

    if (categoryLabel instanceof Date) {
        if (window.chartLanguage === "fr") {
            var month = categoryLabel.getMonth();
            month = AmCharts.translations.fr.shortMonthNames[month];
            var year = categoryLabel.getFullYear();
            var day = categoryLabel.getDate();
            if (day === 1) {
                day = day + "<sup>er</sup>";
            }
            label = day + ' ' + month + ' ' + year;
        } else {
            label = AmCharts.formatDate(categoryLabel, "MMM D, YYYY");
        }
    }

    return label;
};

/**
 * Returns the proper monthly label based on the date
 * @param {date} date    the date object
 * @returns {string}     the proper formatted month string
 */
bocAmchart.monthlyFunction = function (date) {
    var monthlyDate;

    if (window.chartLanguage === "fr") {
        var month = date.getMonth();
        month = AmCharts.translations.fr.shortMonthNames[month];
        var year = date.getFullYear();

        monthlyDate = month + ' ' + year;
    } else {
        monthlyDate = AmCharts.formatDate(date, "MMM YYYY");
    }

    return monthlyDate;
};

/**
 * Returns the proper annual label based on the date
 * @param {date} date    the date object
 * @returns {string}     the full year of the date
 */
bocAmchart.annualFunction = function (date) {
    return date.getFullYear();
};

/**
 * Finds all the last value and assigns it based on series data attribute
 *
 * @param {object} chart AMChart object
 * @param {object} data Object containing the valet data sets after postProcessor
 * @returns {void} Updates DOM
 */
bocAmchart.updateLastValues = function (chart, data) {

    var $valueFields = jQuery("#" + chart.bocSettings.id).parent().find(".boc_last_value");
    var valueFieldsIndex = [];
    $valueFields.each(function (i, valueField) {
        if (valueField) {
            var $valueField = jQuery(valueField);
            var seriesItem = $valueField.data('series');
            valueFieldsIndex[i] = {};
            if (seriesItem) {
                valueFieldsIndex[i].series = seriesItem;
            }
            valueFieldsIndex[i].span = $valueField;
        }
    });

    if (bocAmchart.debug(chart)) {
        // eslint-disable-next-line no-console
        console.log(
            chart.bocSettings.id,
            "Updating last values:",
            bocAmchart.debugClone(valueFieldsIndex),
            bocAmchart.debugClone(chart),
            "Data:",
            data
        );
    }

    var fieldsCount = valueFieldsIndex.length;
    for (var i = data.length; i > 0 && fieldsCount > 0; i--) {
        valueFieldsIndex.forEach(function (valueField) {
            if (valueField.hasOwnProperty("value")) {
                return;
            }
            // Grab the last data point
            var dataPoint = data[i - 1];

            if (valueField.hasOwnProperty("series")) {
                if (dataPoint.hasOwnProperty(valueField.series)) {
                    valueField.value = dataPoint[valueField.series];
                    fieldsCount--;
                }
            }
        });
    }

    valueFieldsIndex.forEach(function (valueField) {
        if (!valueField.hasOwnProperty("value")) {
            return;
        }
        valueField.span.html(valueField.value);
    });

    if (bocAmchart.debug(chart)) {
        // eslint-disable-next-line no-console
        console.log(
            chart.bocSettings.id,
            valueFieldsIndex.length ? "Value fields found:" : "Did not find any value fields:",
            bocAmchart.debugClone(valueFieldsIndex)
        );
    }
};

/**
 * Finds all the last observation dates and assigns the dates based on series data attribute
 *
 * @param {object} chart AMChart object
 * @param {object} data Object containing the valet data sets after postProcessor
 * @returns {void} Updates DOM
 */
bocAmchart.updateLastModifiedDates = function (chart, data) {

    var $dateFields = jQuery("#" + chart.bocSettings.id).parent().find(".boc_last_observation_date");
    var dateFieldsIndex = [];
    $dateFields.each(function (i, dateField) {
        if (dateField) {
            var $dateField = jQuery(dateField);
            var seriesItem = $dateField.data('series');
            dateFieldsIndex[i] = {};
            if (seriesItem) {
                dateFieldsIndex[i].series = seriesItem;
            }
            dateFieldsIndex[i].span = $dateField;
        }
    });

    if (bocAmchart.debug(chart)) {
        // eslint-disable-next-line no-console
        console.log(
            chart.bocSettings.id,
            "Updating last modified dates:",
            bocAmchart.debugClone(dateFieldsIndex),
            bocAmchart.debugClone(chart),
            "Data:",
            data
        );
    }

    var fieldsCount = dateFieldsIndex.length;
    for (var i = data.length; i > 0 && fieldsCount > 0; i--) {
        dateFieldsIndex.forEach(function (dateField) {
            if (dateField.hasOwnProperty("formattedDate")) {
                return;
            }
            var dataPoint = data[i - 1];
            if (dataPoint.hasOwnProperty('date') &&
                (!dateField.hasOwnProperty('series') || dataPoint.hasOwnProperty(dateField.series))
            ) {
                if (chart.chartCursor !== null &&
                    chart.chartCursor.hasOwnProperty('categoryBalloonFunction') &&
                    typeof chart.chartCursor.categoryBalloonFunction === 'function') {
                    var date = new Date(dataPoint.date);
                    if (date.getTimezoneOffset() > 0) {
                        date.setTime(date.getTime() + date.getTimezoneOffset() * 60 * 1000);
                    }
                    dateField.formattedDate = chart.chartCursor.categoryBalloonFunction(date);
                } else {
                    dateField.formattedDate = dataPoint.date;
                }
                fieldsCount--;
            }
        });
    }

    dateFieldsIndex.forEach(function (dateField) {
        if (!dateField.hasOwnProperty("formattedDate")) {
            return;
        }
        dateField.span.html(dateField.formattedDate);
    });

    if (bocAmchart.debug(chart)) {
        // eslint-disable-next-line no-console
        console.log(
            chart.bocSettings.id,
            dateFieldsIndex.length ? "Date fields with dates found:" : "Did not find any date fields:",
            bocAmchart.debugClone(dateFieldsIndex)
        );
    }
};

/**
 * Hook to a drawn event the function to zoom the recent range in years
 * @param {AMConfig} chartSettings Object The settings to be used to build this chart
 * @param {int} years number of years to zoom
 * @return {void}
 */
bocAmchart.zoomRecentYears = function (chartSettings, years) {
    bocAmchart.initChartVars(chartSettings);
    bocAmchart.vars[chartSettings.bocSettings.id].years = years;
    bocAmchart.vars[chartSettings.bocSettings.id].zoomed = 0;
    chartSettings.listeners.push({
        "event": "drawn",
        "method": bocAmchart.zoomRecentYearsHandler
    });
};

/**
 * Function to run on drawn event to zoom and remove event handler
 * @param {object} event The AMChart drawn event
 * @return {void}
 */
bocAmchart.zoomRecentYearsHandler = function (event) {
    // There are two drawn events and only the second seems to be actually relevant for zooming
    // rendered event suggested in docs is too early and does not seem to work in our case
    if (bocAmchart.vars[event.chart.bocSettings.id].zoomed++ < 2) {
        var years = bocAmchart.vars[event.chart.bocSettings.id].years;
        event.chart.zoomToDates(new Date(new Date().setFullYear(new Date().getFullYear() - years)), new Date());
    }
};

/**
 * Hook to a drawn event the function to zoom the recent range in years
 * @param {AMConfig} chartSettings Object The settings to be used to build this chart
 * @param {string} date number of years to zoom
 * @return {void}
 */
bocAmchart.zoomFromDate = function (chartSettings, date) {
    bocAmchart.initChartVars(chartSettings);
    bocAmchart.vars[chartSettings.bocSettings.id].zoomStart = date;
    bocAmchart.vars[chartSettings.bocSettings.id].zoomed = 0;
    chartSettings.listeners.push({
        "event": "drawn",
        "method": bocAmchart.zoomFromDateHandler
    });
};

/**
 * Function to run on drawn event to zoom and remove event handler
 * @param {object} event The AMChart drawn event
 * @return {void}
 */
bocAmchart.zoomFromDateHandler = function (event) {
    // There are two drawn events and only the second seems to be actually relevant for zooming
    // rendered event suggested in docs is too early and does not seem to work in our case
    if (bocAmchart.vars[event.chart.bocSettings.id].zoomed++ < 2) {
        var zoomStart = bocAmchart.vars[event.chart.bocSettings.id].zoomStart;
        event.chart.zoomToDates(new Date(zoomStart), new Date());
    }
};

/**
 * Hook to a drawn event the function to zoom the recent range in years
 * @param {AMConfig} chartSettings Object The settings to be used to build this chart
 * @param {date} dateStart Object The start date for zoom
 * @param {date} dateEnd Object The end date for zoom
 * @return {void}
 */
bocAmchart.zoomBetweenDates = function (chartSettings, dateStart, dateEnd) {
    bocAmchart.initChartVars(chartSettings);
    bocAmchart.vars[chartSettings.bocSettings.id].zoomStart = dateStart;
    bocAmchart.vars[chartSettings.bocSettings.id].zoomEnd = dateEnd;
    bocAmchart.vars[chartSettings.bocSettings.id].zoomed = 0;
    chartSettings.listeners.push({
        "event": "drawn",
        "method": bocAmchart.zoomBetweenDatesHandler
    });
};

/**
 * Function to run on drawn event to zoom
 * @param {object} event The AMChart drawn event
 * @return {void}
 */
bocAmchart.zoomBetweenDatesHandler = function (event) {
    // There are two drawn events and only the second seems to be actually relevant for zooming
    // rendered event suggested in docs is too early and does not seem to work in our case
    if (bocAmchart.vars[event.chart.bocSettings.id].zoomed++ < 2) {
        event.chart.zoomToDates(
            bocAmchart.vars[event.chart.bocSettings.id].zoomStart,
            bocAmchart.vars[event.chart.bocSettings.id].zoomEnd
        );
    }
};

/**
 * Hook to a drawn event the function to zoom the range in indexes
 * @param {AMConfig} chartSettings Object The settings to be used to build this chart
 * @param {date} indexStart Object The start index for zoom
 * @param {date} indexEnd Object The end index for zoom
 * @return {void}
 */
bocAmchart.zoomBetweenIndexes = function (chartSettings, indexStart, indexEnd) {
    bocAmchart.initChartVars(chartSettings);
    bocAmchart.vars[chartSettings.bocSettings.id].zoomStart = indexStart;
    bocAmchart.vars[chartSettings.bocSettings.id].zoomEnd = indexEnd;
    bocAmchart.vars[chartSettings.bocSettings.id].zoomed = 0;
    chartSettings.listeners.push({
        "event": "drawn",
        "method": bocAmchart.zoomBetweenIndexesHandler
    });
};

/**
 * Function to run on drawn event to zoom
 * @param {object} event The AMChart drawn event
 * @return {void}
 */
bocAmchart.zoomBetweenIndexesHandler = function (event) {
    // There are two drawn events and only the second seems to be actually relevant for zooming
    // rendered event suggested in docs is too early and does not seem to work in our case
    if (bocAmchart.vars[event.chart.bocSettings.id].zoomed++ < 2) {
        event.chart.zoomToIndexes(
            bocAmchart.vars[event.chart.bocSettings.id].zoomStart,
            bocAmchart.vars[event.chart.bocSettings.id].zoomEnd
        );
    }
};

/**
 * Set the minimum period as well as the cursor function based on period shortcode argument
 *
 * @param {object} chart AMChart object
 * @returns {void} Updates chart object
 */
bocAmchart.setMinPeriodAndCategoryBalloonFunction = function (chart) {

    var baloonFunction;
    //Default date unless set otherwise in wp-admin
    if (chart.hasOwnProperty("chartCursor")
        && chart.chartCursor !== null
        && !chart.chartCursor.categoryBalloonFunction) {
        baloonFunction = bocAmchart.defaultDate;
    }

    if (chart.bocSettings.args.hasOwnProperty("period")) {
        if (chart.hasOwnProperty("categoryAxis")) {
            switch (chart.bocSettings.args.period) {
                case "day":
                    chart.categoryAxis.minPeriod = "DD";
                    break;
                case "month":
                    chart.categoryAxis.minPeriod = "MM";
                    baloonFunction = bocAmchart.monthlyFunction;
                    break;
                case "quarter":
                    chart.categoryAxis.minPeriod = "3MM";
                    baloonFunction = bocAmchart.quarterFunction;
                    break;
                case "year":
                    chart.categoryAxis.minPeriod = "YYYY";
                    baloonFunction = bocAmchart.annualFunction;
                    break;
                default:
                    chart.categoryAxis.minPeriod = chart.bocSettings.args.period;
            }
        }
    }

    // Allow override of the category function from the shortcode
    if (chart.bocSettings.args.hasOwnProperty("categoryfunction")) {
        if (typeof bocAmchart[chart.bocSettings.args.categoryfunction] === "function") {
            baloonFunction = bocAmchart[chart.bocSettings.args.categoryfunction];
        }
    }

    if (chart.hasOwnProperty("chartCursor") && chart.chartCursor !== null) {
        chart.chartCursor.categoryBalloonFunction = baloonFunction;
    }
};
